jQuery(document).ready(function($){


  $(".why_choose_inner_voice_section_main .group-block-content h2").prependTo(".why_choose_inner_voice_section_main .custom-section-content");

   

    $('.custom-image-block-section').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
})




document.addEventListener("DOMContentLoaded", function () {
    const maxHeight = 500; // height before collapse
    const elements = document.querySelectorAll(".why_choose_inner_voice_section_main rte-formatter");

    elements.forEach(function (el) {
        if (el.scrollHeight > maxHeight) {

            el.style.maxHeight = maxHeight + "px";
            el.style.overflow = "hidden";

            const btn = document.createElement("span");
            btn.className = "read-more-btn";
            btn.innerText = "Read More";

            el.after(btn);

            btn.addEventListener("click", function () {
                if (btn.innerText === "Read More") {
                    el.style.maxHeight = el.scrollHeight + "px";
                    btn.innerText = "Read Less";
                } else {
                    el.style.maxHeight = maxHeight + "px";
                    btn.innerText = "Read More";
                }
            });
        }
    });
});